<template>
  <div class="pb-75px">
    <main class="main reception">
        <div class="section form-group">
          <ValidationObserver v-slot="{ invalid, errors }" ref="validform" slim>
            <div class="document-wrapper">
              <div v-if="isImageUploaded">
                <div class="uploaded-id-file">
                  <div v-if="verifyType === 'residentRegisterationCertificate'">
                    <img src="@/assets/images/kyc/sample-id-card.png" class="w-100" alt="sample-id-card" />
                  </div>
                  <div v-else>
                    <img src="@/assets/images/kyc/sample-driver-license-card.png" class="w-100" alt="sample-driver-license-card" />
                  </div>
                </div>
                <p class="info-text">제출한 신분증은 개인정보 보호로<br> 화면에 보이지 않습니다.</p>
              </div>
              <div v-else>
                <div class="skeleton">
                  <div class="skeleton-text">
                    <h2 class="skeleton-title"></h2>
                    <p class="skeleton-description">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </p>
                    <a href="#" class="skeleton-link"></a>
                  </div>
                  <div class="skeleton-img"></div>
                </div>
              </div>
              <div class="button-wrapper">
                <input
                  class="d-none"
                  ref="uploader"
                  type="file"
                  accept="image/*"
                  capture="camera"
                  @change="uploadFile($event.target.files)"
                />
                <v-btn class="upload-button" @click="uploadButton">업로드하기</v-btn>
              </div>
            </div>
              <div v-if="isImageUploaded">
                <span class="guide-text">아래 항목들을 기재해 주세요.</span>
                <div class="field-group verifyType">
                  <button
                    v-ripple
                    type="button"
                    @click="selectVerifyType('residentRegisterationCertificate')"
                    name="verifyType"
                    :class="{'selected': verifyType === 'residentRegisterationCertificate'}"
                  >주민등록증</button>
                  <button
                    v-ripple
                    type="button"
                    @click="selectVerifyType('driverLicense')"
                    name="verifyType"
                    :class="{'selected': verifyType === 'driverLicense'}"
                  >운전면허증</button>
                </div>
                <div class="form-group" v-if="verifyType === 'residentRegisterationCertificate'">
                  <div class="field-group name flex">
                    <FormInput
                      type="text"
                      name="name"
                      v-model="residentRegisterationCertificate.name"
                      rules="required"
                      placeholder="대표자(사업자등록증 상)이름을 입력해주세요."
                      :disabled="residentRegisterationCertificate.name"
                    />
                    <p
                      v-if="errors.name != null && errors.name[0] != null"
                      class="error-text"
                    >{{errors.name[0]}}</p>
                  </div>
                  <div class="field-group name flex">
                    <FormInput
                      type="text"
                      name="issue_date"
                      v-model="residentRegisterationCertificate.issue_date"
                      rules="required"
                      placeholder="발급일을 입력해주세요."
                    />
                    <p
                      v-if="errors.name != null && errors.issue_date[0] != null"
                      class="error-text"
                    >{{errors.issue_date[0]}}</p>
                  </div>
                  <div class="field-group name d-flex jumin">
                    <FormInput
                      type="text"
                      v-model="displayJuminBirth"
                      disabled
                    />
                    -
                    <span class="gender-text">{{ displayJuminGender }}</span>
                    <FormInput
                      type="text"
                      name="restJuminNumber"
                      v-model="restJuminNumber"
                      rules="required|restJuminNumber"
                      :maxlength="6"
                      placeholder="주민등록번호 뒤 6자리를 입력해주세요."
                    />
                  </div>
                  <div class="field-group mb-0">
                    <p
                      v-if="errors.restJuminNumber != null && errors.restJuminNumber[0] != null"
                      class="error-text"
                    >{{errors.restJuminNumber[0]}}</p>
                  </div>
                </div>
                <div class="form-group" v-else>
                  <div class="separate-line"></div>
                  <div class="field-group newOrOld-eg">
                    <span>11-11-111111-11</span>
                    <span>서울 11-111111-11</span>
                  </div>
                  <div class="field-group newOrOld">
                      <button
                        v-ripple
                        type="button"
                        @click="selectNewOrOld('new')"
                        name="newOrOld"
                        :class="{'selected': driverLicense.new_or_old === 'new'}"
                      >신형</button>
                    <button
                      v-ripple
                      type="button"
                      @click="selectNewOrOld('old')"
                      name="newOrOld"
                      :class="{'selected': driverLicense.new_or_old === 'old'}"
                    >구형</button>
                  </div>
                  <template v-if="driverLicense.new_or_old === 'new'">
                    <div class="field-group name flex">
                      <FormInput
                        type="text"
                        name="issued_number"
                        v-model="driverLicense.new.issued_number"
                        rules="required"
                        placeholder="운전면허번호를 입력해주세요."
                      />
                      <p
                        v-if="errors.issued_number != null && errors.issued_number[0] != null"
                        class="error-text"
                      >{{errors.issued_number[0]}}</p>
                    </div>
                  </template>
                  <template v-else>
                    <div class="field-group phone">
                        <FormSelect
                          name="area_number"
                          rules="required"
                          v-model="driverLicense.area_number"
                          :options="areas"
                        />
                        <FormInput
                          type="text"
                          name="issued_number"
                          v-model="driverLicense.old.issued_number"
                          rules="required"
                          placeholder="운전면허번호를 입력해주세요."
                        />
                    </div>
                    <p
                      v-if="errors.issued_number != null && errors.issued_number[0] != null"
                      class="error-text"
                      style="margin-bottom: 8px;"
                    >{{errors.issued_number[0]}}</p>
                  </template>
                  <div class="field-group name flex">
                    <FormInput
                      type="text"
                      name="password_serial_number"
                      v-model="driverLicense.password_serial_number"
                      rules="required|password_serial_number"
                      :maxlength="6"
                      placeholder="일련번호를 입력해주세요."
                    />
                      <p
                        v-if="errors.password_serial_number != null && errors.password_serial_number[0] != null"
                        class="error-text"
                      >{{errors.password_serial_number[0]}}</p>
                  </div>
                  <div class="field-group name d-flex jumin">
                    <FormInput
                      type="text"
                      v-model="displayJuminBirth"
                      disabled
                    />
                    -
                    <span class="gender-text">{{ displayJuminGender }}</span>
                    <FormInput
                      type="text"
                      name="restJuminNumber"
                      v-model="restJuminNumber"
                      rules="required|restJuminNumber"
                      :maxlength="6"
                      placeholder="주민등록번호 뒤 6자리를 입력해주세요."
                    />
                  </div>
                  <div class="field-group mb-0">
                    <p
                      v-if="errors.restJuminNumber != null && errors.restJuminNumber[0] != null"
                      class="error-text"
                    >{{errors.restJuminNumber[0]}}</p>
                  </div>
                </div>
              </div>
              <div class="section bottom">
                <button
                  v-ripple
                  class="button next-button"
                  :disabled="!isImageUploaded || invalid || isInProgress"
                  type="button"
                  @click="next"
                >
                  인증하기
                  <v-progress-circular
                    style="padding-left: 15px;"
                    size="24"
                    v-if="isInProgress"
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </button>
              </div>
          </ValidationObserver>
        </div>
    </main>
  </div>
</template>
<script>
import AuthService from '@/service/auth/AuthService'
import KycService from '@/service/kyc/KycService'
import UserService from '@/service/user/UserService'

import contractsApi from '@/api/now/contractsApi'

import FormInput from '@/components/form/FormInput'
import FormSelect from '@/components/form/FormSelect'

export default {
  components: {
    FormInput,
    FormSelect,
  },
  data() {
    return {
      user: {},
      displayJuminBirth: null,
      displayJuminGender: null,
      preJuminNumber: null,
      restJuminNumber: null,
      verifyType: 'residentRegisterationCertificate',
      residentRegisterationCertificate: {
        jumin: null,
        issue_date: null,
        image: null,
      },
      driverLicense: {
        new_or_old: 'new',
        new: {
          issued_number: null,
        },
        old: {
          issued_number: null,
        },
        jumin: null,
        area_number: 11,
        year_number: null,
        serial_number: null,
        ending_number: null,
        password_serial_number: null,
        image: null,
      },
      document: {
        identification: { title: '신분증사본', file: null },
      },
      areas: [{
        label: '서울(11)',
        value: '서울'
      }, {
        label: '부산(12)',
        value: '부산'
      }, {
        label: '경기(13)',
        value: '경기'
      }, {
        label: '강원(14)',
        value: '강원'
      }, {
        label: '충북(15)',
        value: '충북'
      }, {
        label: '충남(16)',
        value: '충남'
      }, {
        label: '전북(17)',
        value: '전북'
      }, {
        label: '전남(18)',
        value: '전남'
      }, {
        label: '경북(19)',
        value: '경북'
      }, {
        label: '경남(20)',
        value: '경남'
      }, {
        label: '제주(21)',
        value: '제주'
      }, {
        label: '대구(22)',
        value: '대구'
      }, {
        label: '인천(23)',
        value: '인천'
      }, {
        label: '광주(24)',
        value: '광주'
      }, {
        label: '대전(25)',
        value: '대전'
      }, {
        label: '울산(26)',
        value: '울산'
      }],
      isInProgress: false,
    }
  },
  watch: {
    'driverLicense.new.issued_number': function (value) {
      this.driverLicense.new.issued_number = value.match(/\d*/g).join('')
        .match(/(\d{0,2})(\d{0,2})(\d{0,6})(\d{0,2})/).slice(1).join('-')
        .replace(/-*$/g, '')
    },
    'driverLicense.old.issued_number': function (value) {
      this.driverLicense.old.issued_number = value.match(/\d*/g).join('')
        .match(/(\d{0,2})(\d{0,6})(\d{0,2})/).slice(1).join('-')
        .replace(/-*$/g, '')
    },
    'residentRegisterationCertificate.issue_date': function (value) {
      this.residentRegisterationCertificate.issue_date = value.match(/\d*/g).join('')
        .match(/(\d{0,4})(\d{0,2})(\d{0,2})/).slice(1).join('-')
        .replace(/-*$/g, '')
    },
  },
  async created() {
    this.$store.commit('ui/headerTitle', '신분증 제출하기')
    this.user = await AuthService.getProfile()
    if (this.user.birthdate && this.user.gender) {
      const birthdates = this._.split(this.user.birthdate, '-')
      let genderNumber = this.user.gender === 'male' ? 1 : 2
      if (parseInt(birthdates[0]) >= 2000) {
        genderNumber = this.user.gender === 'male' ? 3 : 4
      }
      this.displayJuminBirth = birthdates[0].substring(2) + birthdates[1] + birthdates[2]
      this.displayJuminGender = genderNumber
      this.preJuminNumber = birthdates[0].substring(2) + birthdates[1] + birthdates[2] + genderNumber
      this.residentRegisterationCertificate.name = this.user.name
    }
  },
  computed: {
    isImageUploaded() {
      return !!this.residentRegisterationCertificate.image || !!this.driverLicense.image
    },
  },
  methods: {
    selectVerifyType(value) {
      this.verifyType = value
      this.$nextTick(_ => {
        this.$refs.validform.validate()
      })
    },
    selectNewOrOld(value) {
      this.driverLicense.new_or_old = value
    },
    uploadButton() {
      this.$refs.uploader.click()
    },
    // Input Function Section
    uploadFile: function (newFile, oldFile, document) {
      if (!newFile) { return }
      let file = newFile[0]

      this.residentRegisterationCertificate.image = this.driverLicense.image = file
      this.patchDocument(file)
      this.$nextTick(_ => {
        this.$refs.validform.validate()
      })
    },
    // Patch Function Section
    async patchDocument(file) {
      let formdata = new FormData()
      formdata.append(this.name, file)
      let { data } = await contractsApi.patchDocuments(formdata)
      this.document.identification.file = data[this.name]
    },
    async next() {
      if (this.isInProgress === true) {
        return
      }

      this.isInProgress = true

      try {
        if (this.verifyType === 'residentRegisterationCertificate') {
          await this.verifyResidentRegisterationCertificate()
        } else {
          await this.verifyDriverLicense()
        }
      } catch (e) {
        this.isInProgress = false
      }
    },
    async verifyResidentRegisterationCertificate() {
      try {
        const formData = new FormData()
        this.residentRegisterationCertificate.jumin = this.preJuminNumber + this.restJuminNumber
        formData.append('jumin', this.residentRegisterationCertificate.jumin)
        formData.append('issue_date', this.residentRegisterationCertificate.issue_date)
        formData.append('image', this.residentRegisterationCertificate.image)
        let { data } = await KycService.postVerifyResidentRegistrationCertificate(formData)
        if (data.result) {
          let confirm = await this.$swal.fire({
            html: '신분증 인증이 완료됐습니다.',
            confirmButtonText: '확인'
          })
          if (confirm.isConfirmed) {
            await AuthService.syncProfile()
            let isExistingCustomer = await UserService.isExistingCustomer()
            if (isExistingCustomer) {
              this.$router.push({ name: 'kyc/verify-withdrawal-account' })
            } else {
              this.$router.push({ name: 'documents' })
            }
          }
        } else {
          await this.$swal.fire({
            html: data.message,
            confirmButtonText: '확인'
          })
        }
      } catch (e) {
        let data = e.data
        this.$swal.fire({
          html: data['message'] || data['jumin'][0] || '신분증 인증하는데 문제가 발생했습니다.',
          confirmButtonText: '확인'
        })
      } finally {
        this.isInProgress = false
      }
    },
    async verifyDriverLicense() {
      try {
        let issuedNumber = []
        if (this.driverLicense.new_or_old === 'new') {
          issuedNumber = this.driverLicense.new.issued_number.split('-')
        } else {
          issuedNumber = this.driverLicense.old.issued_number.split('-')
        }

        const formData = new FormData()
        this.driverLicense.jumin = this.preJuminNumber + this.restJuminNumber
        formData.append('jumin', this.driverLicense.jumin)
        if (this.driverLicense.new_or_old === 'new') {
          formData.append('area_number', issuedNumber[0])
          formData.append('year_number', issuedNumber[1])
          formData.append('serial_number', issuedNumber[2])
          formData.append('ending_number', issuedNumber[3])
        } else {
          formData.append('area_number', this.driverLicense.area_number)
          formData.append('year_number', issuedNumber[0])
          formData.append('serial_number', issuedNumber[1])
          formData.append('ending_number', issuedNumber[2])
        }
        formData.append('password_serial_number', this.driverLicense.password_serial_number)
        formData.append('image', this.driverLicense.image)

        let { data } = await KycService.postVerifyDriverLicense(formData)
        if (data.result) {
          let confirm = await this.$swal.fire({
            html: '신분증 인증이 완료됐습니다.',
            confirmButtonText: '확인'
          })
          if (confirm.isConfirmed) {
            await AuthService.syncProfile()
            let isExistingCustomer = await UserService.isExistingCustomer()
            if (isExistingCustomer) {
              this.$router.push({ name: 'kyc/verify-withdrawal-account' })
            } else {
              this.$router.push({ name: 'documents' })
            }
          }
        } else {
          await this.$swal.fire({
            html: data.message,
            confirmButtonText: '확인'
          })
        }
      } catch (e) {
        let data = e.data
        this.$swal.fire({
          html: data['message'] || data['jumin'][0] || '신분증 인증하는데 문제가 발생했습니다.',
          confirmButtonText: '확인'
        })
      } finally {
        this.isInProgress = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.document-wrapper {
  .image {
    padding: 0 27px;
    img {
      min-height: 180px;
    }
  }

  .uploaded-id-file {

    .description {
      width: 100%;
      height: auto;
      margin-top: 6px;
      font-size: 14px;
      line-height: 16px;
      color: #727d8c;
    }
  }

  .skeleton {
    display: flex;
    justify-content: space-around;
    padding: 20px;
    max-width: 400px;
    height: 166px;
    margin: 0 auto 20px;
    border-radius: 10px;
    background-color: #E2E8F0;
    box-shadow:
      0 9px 33px rgba(0, 0, 0, 0.07);

    &-text{
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 70%;
      margin-right: 10px;
    }

    &-img{
      width: 75px;
      height: 75px;
      border-radius: 50%;
      background-color: #94A3B8;
      animation: pulse 2s infinite ease-in-out;
    }

    &-description{
      margin: 10px 0;

      span {
        &:nth-child(1){
          display: block;
          width: 60px;
          height: 10px;
          background-color: #94A3B8;
        }

        &:nth-child(2){
          display: block;
          width: 100%;
          height: 10px;
          background-color: #94A3B8;
          margin-top: 5px;
        }

        &:nth-child(3){
          display: block;
          width: 100px;
          height: 10px;
          background-color: #94A3B8;
          margin-top: 5px;
        }

        &:nth-child(4){
          display: block;
          width: 50px;
          height: 10px;
          background-color: #94A3B8;
          margin-top: 5px;
        }
      }
    }

    &-link{
      width: 75px;
      height: 12px;
      background-color: #94A3B8;
      margin-top: 40px;
    }

    &-skills{
      display: flex;
      justify-content: space-between;

      .skill {
        width: 20%;
        height: 12px;
        background-color: #94A3B8;
        list-style: none;
      }
    }
  }
}
.newOrOld-eg {
  span {
    font-size: 14px;
    &:first-child {
      width: 50%;
    }
    &:last-child {
      margin-left: 2.77%;
    }
  }
}

.jumin {
  align-items: center;
}

.button-wrapper {
  text-align: center;

  button {
    color: #FFFFFF !important;
    background-color: #1baaf1 !important;
    border-color: #1baaf1;
    font-weight: 600;
    border-radius: 5px;
    padding: 10px 16px;
  }
}

.separate-line {
  width: 100%;
  height: 1px;
  margin: 20px 0;
  border-bottom: 1px solid rgba(0,0,0, 0.1);
}

.info-text {
  font-size: 93%;
  font-weight: 600;
  text-align: center;
  margin-bottom: 17px;
}

.guide-text {
  display: block;
  font-size: 16px;
  margin-top: 20px;
  margin-bottom: 10px;
  text-align: center;
}

.red-border {
  border-color: #ff1616;
}

.form-group {
  padding-bottom: 30px;
}
</style>
